const deleteSubmission =  `mutation deleteSubmission($personId: String!, $datetime: String!) {
  deleteSubmission(personId: $personId, datetime: $datetime) {
    personId
  }
}`

export default deleteSubmission;


// WEBPACK FOOTER //
// ./src/graphql/mutations.js